import "./styles.scss";
import {MdLocationPin,} from "react-icons/md";
import {AiOutlineMail} from "react-icons/ai";
import {BsFillDoorOpenFill} from "react-icons/bs";



const Home = ({setSection}) => {

    const authors = 
        {
            FernandoFerreira: "https://webpages.ciencias.ulisboa.pt/~fjferreira/index_english.html",
            BrunoDinis: "https://www.uevora.pt/pessoas?id=244557/",
            LaurentiuLeustean: "https://cs.unibuc.ro/~lleustean/",
            UlrichKohlenbach: "https://www2.mathematik.tu-darmstadt.de/~kohlenbach/",
            NicholasPischke: "https://sites.google.com/view/nicholaspischke/home/",
        }
    


    const articles = [
        /*
        {
            title: "TITULO DO ARTIGO",
            coauthor1: "CO-AUTOR 1",
            coauthor1Link: "HOMEPAGE DO CO-AUTOR 1", 
            coauthor2: "CO-AUTOR 2",
            coauthor2Link: "HOMEPAGE DO CO-AUTOR 2",
            journal: "JOURNAL ou SUBMITTED(YEAR) ou TO APPEAR",
            pdf: "ENDEREÇO DO PDF",
            doi: "COLOCAR DOI"
        }
        */
        {   
            title: "Proof mining and the convex feasibility problem: the curious case of Dykstra's algorithm",
            journal: <>submitted (2024), 31pp</>,
            pdf: "/~pinto/articles/L-Dykstra.pdf",
            doi: ""
        },
        {   
            title: "The alternating Halpern-Mann iteration for families of maps",
            coauthor1: "Paulo Firmino",
            journal: <>submitted (2024), 23pp</>,
            pdf: "/~pinto/articles/HM2.pdf",
            doi: ""
        },
        {   
            title: "On Dykstra's algorithm with Bregman projections",
            coauthor1: "Nicholas Pischke",
            coauthor1Link: "https://sites.google.com/view/nicholaspischke/",
            journal: <>submitted (2024), 17pp, <a href="https://doi.org/10.14760/OWP-2024-04" target="_blank">Oberwolfach Preprint</a></>,
            pdf: "/~pinto/articles/B-Dykstra.pdf",
            doi: ""
        },
        {   title: "Nonexpansive maps in nonlinear smooth spaces",
            journal: "To appear in: Transactions of the American Mathematical Society, 47pp (2024)",
            pdf: "/~pinto/articles/smooth.pdf",
            doi: "https://doi.org/10.1090/tran/9166"
        },
        {   title: "Fejér monotone sequences revisited",
            coauthor1: "Ulrich Kohlenbach",
            coauthor1Link: "https://www2.mathematik.tu-darmstadt.de/~kohlenbach/",
            journal: "submitted (2024), 14pp",
            pdf: "/~pinto/articles/fejer-revisited.pdf",
            doi: ""
        },
        {   title: "On the finitary content of Dykstra's cyclic projections algorithm",
            journal: "To appear in: Zeitschrift für Analysis und ihre Anwendungen, 28pp (2024)",
            pdf: "/~pinto/articles/Dykstra.pdf",
            doi: ""
        },
        {   title: "On computational properties of Cauchy problems generated by accretive operators",
            coauthor1: "Nicholas Pischke",
            coauthor1Link: "https://sites.google.com/view/nicholaspischke/home/",
            journal: "Documenta Mathematica 28(5): 1235–1274 (2023)",
            pdf: "/~pinto/articles/ConvergenceCondition.pdf",
            doi: "https://doi.org/10.4171/dm/924"
        },
        {
            title: "Rates of asymptotic regularity for the alternating Halpern-Mann iteration",
            coauthor1: "Laurenţiu Leuştean",
            coauthor1Link: "https://cs.unibuc.ro/~lleustean/",
            journal: "Optimization Letters 18: 529–543 (2024)",
            pdf: "/~pinto/articles/HM_UCW.pdf",
            doi: "https://doi.org/10.1007/s11590-023-02002-y"
        },
        {
            title: "Strong convergence for the alternating Halpern-Mann iteration in CAT(0) spaces",
            coauthor1: "Bruno Dinis",
            coauthor1Link: "https://www.uevora.pt/pessoas?id=244557/",
            journal: "SIAM Journal on Optimization, 33(2), 785-815 (2023)",
            pdf: "/~pinto/articles/HM.pdf",
            doi: "https://doi.org/10.1137/22M1511199"
        },
        {
            title: "Quantitative translations for viscosity approximation methods in hyperbolic spaces",
            coauthor1: "Ulrich Kohlenbach",
            coauthor1Link: "https://www2.mathematik.tu-darmstadt.de/~kohlenbach/",
            journal: "Journal of Mathematical Analysis and Applications, 507: 125823, 33 pp (2022)",
            pdf: "/~pinto/articles/visc.pdf",
            doi: "https://doi.org/10.1016/j.jmaa.2021.125823"
        },
        {
            title: "Effective metastability for a method of alternating resolvents",
            coauthor1: "Bruno Dinis",
            coauthor1Link: "https://www.uevora.pt/pessoas?id=244557/",
            journal: "Fixed Point Theory, 25(1): 61-98 (2024)",
            pdf: "/~pinto/articles/MAR.pdf",
            doi: "https://doi.org/10.24193/fpt-ro.2025.1.05"
        },
        {    
            title: "On the convergence of algorithms with Tikhonov regularization terms",
            coauthor1: "Bruno Dinis",
            coauthor1Link: "https://www.uevora.pt/pessoas?id=244557/",
            journal: "Optimization Letters, 15(4), 1263-1276, (2021)",
            pdf: "/~pinto/articles/TKM.pdf",
            doi: "https://doi.org/10.1007/s11590-020-01635-7"
        },
        {    
            title: "Quantitative results on a Halpern-type proximal point algorithm",
            coauthor1: "Laurenţiu Leuştean",
            coauthor1Link: "https://cs.unibuc.ro/~lleustean/",
            journal: "Computational Optimization and Applications, 79(1), 101-125, (2021)",
            pdf: "/~pinto/articles/HPPA1.pdf",
            doi: "https://doi.org/10.1007/s10589-021-00263-w"
        },
        {    
            title: "Quantitative Results on the Multi-Parameters Proximal Point Algorithm",
            coauthor1: "Bruno Dinis",
            coauthor1Link: "https://www.uevora.pt/pessoas?id=244557/", 
            journal: "Journal of Convex Analysis, 28(3), 729-750, (2021)",
            pdf: "/~pinto/articles/mPPA_WangCui.pdf",
        },
        {    
            title: "A Rate of Metastability for the Halpern Type Proximal Point Algorithm",
            journal: "Numerical Functional Analysis and Optimization, 42(3), 320-343, (2021)",
            pdf: "/~pinto/articles/HPPA2.pdf",
            doi: "https://doi.org/10.1080/01630563.2021.1876726"
        },
        {    
            title: "Metastability of the multi-parameters proximal point algorithm",
            coauthor1: "Bruno Dinis",
            coauthor1Link: "https://www.uevora.pt/pessoas?id=244557/", 
            journal: "Portugaliae Mathematica 77(3/4), 345-381, (2020)",
            pdf: "/~pinto/articles/mPPA_YaoNoor.pdf",
            doi: "https://doi.org/10.4171/PM/2054"
        },
        {    
            title: "On the removal of weak compactness arguments in proof mining",
            coauthor1: "Fernando Ferreira",
            coauthor1Link: "https://webpages.ciencias.ulisboa.pt/~fjferreira/index_english.html", 
            coauthor2: "Laurenţiu Leuştean",
            coauthor2Link: "https://cs.unibuc.ro/~lleustean/",
            journal: "Advances in Mathematics 354: 106728, 55pp, (2019)",
            pdf: "/~pinto/articles/removal.pdf",
            doi: "https://doi.org/10.1016/j.aim.2019.106728"
        },   
    ]

    //para abrir link em novo separador: adicionar no <a target="_blank"

    // Get the hyperlink element
    //var myLink = document.getElementById("myLink");

    // Add a class to the hyperlink
    // myLink.classList.add("special-link");

    //meter como faço para target: id="myLink" class="special-link"

    //<li>Oberwolfach Leibniz Fellow at <i>Mathematisches Forschungsinstitut Oberwolfach</i>, 17 March - 03 June, 2024</li> (colocar na Experiência após contrato)

    return (
        <div className="Home">
            <div className="Home__about-me" id={"about"}>
                <h2>About me</h2>
                <div className={"about-me"}>
                    <div className={"info"}>
                        <MdLocationPin className={"location-icon"}/>
                        <div className={"text"}>Technische Universität Darmstadt, Fachbereich Mathematik<br/>Schlossgartenstraße 7, 64289 Darmstadt, Deutschland</div>
                    </div>

                    <div className={"info"}>
                        <BsFillDoorOpenFill/>
                        <div className={"text"}>Office S2|15 - 203</div>
                    </div>

                    <div className={"info"}>
                        <AiOutlineMail/>
                        <a className={"text"} href="mailto:pinto@mathematik.tu-darmstadt.de">pinto@mathematik.tu-darmstadt.de</a>
                    </div>

                    {/*<div className={"photo"} style={{backgroundImage: `url(${profile_photo})`}}/>*/}
                    <div style={{marginTop: "20px"}}>
                        <p className={"text"}>
                            I am a postdoctoral researcher in the <a target={"_blank"} href="http://www.mathematik.tu-darmstadt.de/logik/arbeitsgruppe_logik/index.en.jsp">Logic
                            group</a> of the <i>Technische Universität Darmstadt</i>, Germany and my postdoc advisor is <a href="https://www2.mathematik.tu-darmstadt.de/~kohlenbach/" target="_blank">Ulrich Kohlenbach</a>.
                            I am also a Research Collaborator of the Institute for Logic and Data Science (<a href="https://ilds.ro/" target="_blank">ILDS</a>, Romania) and of the  Center for Mathematical Studies (<a href="https://cmafcio.ciencias.ulisboa.pt/" target="_blank">CEMS.UL</a>, Portugal).
                            <br/>I am a member of EMS Young Academy (<a href="https://euromathsoc.org/EMYA" target="_blank">EMYA</a>) for the period 2024-2027.
                        </p>
                        <p className={"text"}> My current research is in the sub-area of Mathematical Logic nowadays called <i>Proof Mining</i>, 
                        namely in proof interpretations and their use in mathematics. In this research program, one employs proof-theoretical techniques to analyse 
                        prima facie noneffective mathematical proofs with the goal of uncovering new information, usually in the form of rates, bounds or even qualitative improvements. 
                        My areas of application include Convex Optimization, Fixed Point Theory, Operator Theory, and recently Partial Differential Equations. 
                        I got my PhD in Mathematics in 2019 from the Faculty of Sciences of the University of Lisbon (<a href="/~pinto/docs/phd_thesis.pdf" target="_blanck">thesis</a>) 
                        under the supervision of <a href="https://webpages.ciencias.ulisboa.pt/~fjferreira/index_english.html" target="_blanck">Fernando Ferreira</a>. 
                        Here is my <a href="/~pinto/docs/curriculum_vitae_en.pdf" target="_blank">CV</a> (version 07.2024).
                        </p>
                        <p className={"text"}><strong>Membership:</strong><a href="https://aslonline.org/" target="_blank"> Association for Symbolic Logic</a>; 
                        <a href="https://www.proofsociety.org/the-proof-manifesto/" target="_blank"> Proof Society </a>; 
                        <a href="https://groups.tecnico.ulisboa.pt/~spl.daemon/en/spl-english/" target="_blank"> Sociedade Portuguesa de Lógica</a>;
                        <a href="https://www.spm.pt/" target="_blank"> SPM</a>;
                        <a href="https://euromathsoc.org/" target="_blank"> EMS</a>;
                        <a href="https://www.ams.org/" target="_blank"> AMS</a>
                        </p>
                        <div className={"text"}><strong>Research Interests:</strong> Logic (in particular Proof Theory), Proof Mining, Computability Theory, Convex Optimization,
                        Approximation Theory, Nonlinear Analysis and Fixed Point Theory.
                        </div>
                    </div>
                </div>
            </div>
            <div className="Home__experience" id={"experience"}>
                <h2><b>Experience</b></h2>
                <ul>
                    <li>Postdoc (principal investigator of DFG project PI 2070/1-1) at <i>Technische Universit&auml;t Darmstadt</i>, July 2024 - June 2026</li>
                    <li>Oberwolfach Leibniz Fellow (<a href="https://www.mfo.de/scientific-program/longer-term/oberwolfach-leibniz-fellows" target="_blank">OWLF</a>), March - June 2024</li>
                    <li>Research Assistant at <i>Technische Universit&auml;t Darmstadt</i>, 2020 - June 2024</li>
                    <li>Teacher at <i>Universidade Autónoma de Lisboa</i>, 2018/2019</li>
                    <li>Teaching assistant at <i>Faculdade de Ciências da Universidade de Lisboa</i>, 2012/2013</li>
                </ul>
            </div>
            <div className="Home__articles Section" id={"articles"}>
                <h2><b>Articles</b></h2>
                <ol reversed>
                    {articles.map((article, index) => {
                        return (
                            <li key={index} >
                                <a href={article.pdf} target="_blank">{article.title}</a>
                                {article.coauthor1 && <span>, with <a href={article.coauthor1Link} className="linkunderline" target="_blank">{article.coauthor1}</a></span>}
                                {article.coauthor2 && <span> and <a href={article.coauthor2Link} className="linkunderline" target="_blank">{article.coauthor2}</a></span>}
                                {article.journal && <span><br/>{article.journal}</span>}
                                {article.doi && <span>, <a href={article.doi} target="_blank">DOI</a></span>}
                            </li>)})}
                </ol>
            
                <h2><b>Some Notes</b></h2>
                <ul>
                    <li> <a href="/~pinto/docs/notes/quantXu.pdf" target="_blank">On quantitative versions of Xu's Lemma</a>. April 2023</li>

                </ul>
            </div>

            <div className="Section" id={"events"}>
                <h2><b>Future events</b></h2>
                <ul>
                <li>National Meeting of the Portuguese Mathematical Society (<b><a href="https://enspm2024.spm.pt/" target="_blank">ENSPM 2024</a></b>)
                        <br/>Invited for the parallel session: 'Logic and Theory of Computation'
                        <br/>Talk: <i>&quot;Proof-theoretical unwinding of mathematics&quot;</i>
                        <br/>Universidade do Minho, Braga, Portugal, 10 - 12 July, 2024</li>
                    <li><b><a href="https://sites.google.com/view/wpm24/" target="_blank"> Workshop on Proof Mining 2024</a></b>
                        <br/>First edition of a series of workshops dedicated to proof mining research
                        <br/>TU Darmstadt, Germany, 4 - 6 September, 2024</li>
                </ul>
            </div>
            
            <div className="Section" id={"recent"}>
                <h2><b>Recent</b></h2>
                <ul>
                <li><b>LOS-ILDS Proof Mining Seminar</b>
                        <br/>Talk: <i>&quot;On generalizations to Nonlinear Smooth Spaces&quot;</i>
                        <br/>Faculty of Mathematics and Computer Science, University of Bucharest, (online)  6 March, 2024</li>
                <li><b>Days in Logic 2024</b>
                        <br/>IST University of Lisbon, Lisbon, Portugal, 1-3 February, 2024
                    </li>
                <li><b>Winter Meeting in Lisbon: Mathematics &amp; Applications</b>
                        <br/> Talk: <i>&quot;Sunny nonexpansive retractions in nonlinear spaces&quot;</i>
                        <br/>Faculdade de Ciências, University of Lisbon, Lisbon, Portugal, 18-20 December, 2023
                    </li>
                <li><b>Oberwolfach Workshop on Mathematical Logic: Proof Theory, Constructive Mathematics</b>
                        <br/>Talk: <i>&quot;Sunny nonexpansive retractions in nonlinear spaces&quot;</i>
                        <br/>MFO, Oberwolfach, Germany, 12-18 November, 2023
                    </li>
                     <li><b>Mathematical Logic Seminar at University of Lisbon</b> (SLM)
                        <br/>Talk: <i>&quot;The strange case of Dykstra's algorithm&quot;</i>
                        <br/>Faculdade de Ciências, Universidade de Lisboa, (online) 6 October, 2023
                    </li>
                    <li><b>LOS-ILDS Proof Mining Seminar</b>
                        <br/>Talk: <i>&quot;The strange case of Dykstra's algorithm&quot;</i>
                        <br/>Faculty of Mathematics and Computer Science, University of Bucharest, (online) 26 July, 2023
                    </li>

                    <li><b>Logic Colloquium 2023</b>
                        <br/>Contributed Talk: <i>&quot;Proof mining and the convex feasibility problem&quot;</i>
                        <br/>University of Milan, Italy, 5-9 June 2023
                    </li>

                    <li><b>CIMA/DMat/PDout Seminar</b>
                        <br/>Talk: <i>&quot;On Computational Properties of Cauchy Problems&quot;</i>
                        <br/>Universidade de Évora, Portugal, 22 February, 2023
                    </li>
                </ul>
            </div>

            <div className="Section">
                <h2><b>Past Events</b></h2>
                <ul>
                <li><b>Mathematical Logic Seminar at University of Lisbon</b> (SLM)
                        <br/>Talk: <i>&quot;Proof mining on PDE theory&quot;</i>
                        <br/>Faculdade de Ciências, Universidade de Lisboa, (online) 28 October, 2022
                    </li>

                    <li><b>Colloquium Logicum 2022</b> (CL2022)
                        <br/>Talk: <i>&quot;A generalization via proof mining methods&quot;</i>
                        <br/>University of Konstanz , Konstanz, Germany, 26-28 September, 2022
                    </li>

                    <li><b>International Conference on Applied Proof Theory 2022</b> (APT22)
                        <br/>Talk: <i>&quot;Proof mining on PDE theory&quot;</i>
                        <br/>University of Chieti–Pescara, Pescara, Italy, 29 August-2 September, 2022
                    </li>

                    <li><b>LOS-ILDS Proof Mining Seminar</b>
                        <br/>Talk: <i>&quot;The alternating Halpern-Mann iteration&quot;</i>
                        <br/>Faculty of Mathematics and Computer Science, University of Bucharest, (online) 6 July, 2022
                    </li>

                    <li><b>Days in Logic 2022</b>
                        <br/>Talk: <i>&quot;The Halpern-Mann iteration in UCW-hyperbolic spaces&quot;</i>
                        <br/>University of Algarve, Faro, Portugal, 30 June-2 July, 2022
                    </li>

                    <li><b>LOS-IMAR Logic Seminar</b>
                        <br/>Talk: <i>&quot;Halpern and Mann iterative schemas: A path towards generalization&quot;</i>
                        <br/>Faculty of Mathematics and Computer Science, University of Bucharest, (online) 27 January, 2022
                    </li>

                    <li><b>Mathematical Logic Seminar at University of Lisbon</b> (SLM)
                        <br/>Talk: <i>&quot;Halpern and Mann iterative schemas: A path towards generalization&quot;</i>
                        <br/>Faculdade de Ciências, Universidade de Lisboa, 10 January, 2022
                        <br/>
                    </li>

                    <li><b>New Frontiers in Proofs and Computations</b>
                        <br/>Talk: <i>"Quantitative results on variants of the proximal point algorithm"</i>
                        <br/>Institute for Advanced Study in Mathematics, Hangzhou, China, (online) September 12-17, 2021.
                    </li>

                    <li><b>Eighteenth International Conference on Computability and Complexity in Analysis</b>
                        <br/>Contributed Talk: <i>"Quantitative translations for viscosity approximation methods"</i>
                        <br/>Universität der Bundeswehr München, (online) 26-28 July, 2021.
                    </li>

                    <li><b>FMI/IMAR Logic Seminar</b>
                        <br/>Talk: <i>"Unwinding of proofs"</i>
                        <br/> Faculty of Mathematics and Computer Science, University of Bucharest, (online) 4 March, 2021
                    </li>

                    <li><b>Oberwolfach Workshop on Mathematical Logic: Proof Theory, Constructive Mathematics</b>
                        <br/> MFO, Oberwolfach, Germany (hybrid format), 8-14 November, 2020
                    </li>

                    <li><b>Mathematical Logic Seminar at University of Lisbon</b> (SLM)
                        <br/>Talk: <i>&quot;Quantitative translations for viscosity approximation methods&quot;</i>
                        <br/>Faculdade de Ciências, Universidade de Lisboa, (online) 26 October, 2020
                        <br/></li>

                    <li><b>Mathematical Logic Seminar at University of Lisbon</b> (SLM)
                        <br/>Talk: <i>&quot;Commentaries on the application of the bounded functional
                            interpretation&quot;</i>
                        <br/>Faculdade de Ciências, Universidade de Lisboa, 3 February, 2020
                        <br/></li>

                    <li><b>Days in Logic 2020</b>
                        <br/>Talk: <i>&quot;Proof mining of a discussion by cases&quot;</i>
                        <br/>Faculdade de Ciências, Universidade de Lisboa, Portugal, 30 January-1 February, 2020
                    </li>

                    <li><b>Logic Colloquium 2019 Prague</b> (invited special session speaker)
                        <br/>Special Session on Proof Theory and Proof Complexity
                        <br/>Talk: <i>&quot;Proof mining with the bounded functional interpretation&quot;</i>
                        <br/>Faculty of Architecture, Czech Technical University, Prague, August, 2019
                    </li>

                    <li><b>FMI/IMAR Logic Seminar</b>
                        <br/>Talk: <i>&quot;The bounded functional interpretation and the elimination of weak compactness&quot;</i>
                        <br/>Faculty of Mathematics and Computer Science, University of Bucharest, 26 April, 2018
                    </li>

                    <li><b>Computational Approaches to the Foundations of Mathematics</b>
                        <br/>Talk: <i>&quot;Concrete Examples on the Elimination of Weak Compactness&quot;</i>
                        <br/>Mathematisches Institut, LMU, Munich, 13 April, 2018
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default Home;